import { StoresContextType } from './stores.types';

export const storesMapContextInitialValue: StoresContextType = {
  getters: {
    storeCandidate: undefined,
    isChangeStoreConfirmationModalOpen: false,
    isFetchingStores: false,
    isOnlineRetailer: false,
    stores: [],
  },
  handlers: {
    cancelStoreChange: () => null,
    confirmStoreChange: () => null,
    handleStoreSelection: () => () => null,
  },
};
